import Axios from "./Axios";
import { methods } from "./constants";
import { dataParser, singleValueParser } from "./parse.result";

export const getOnlineUsersCount = () =>
  Axios.get("", {
    params: {
      method: methods.CurrentSessionCount,
      status: "active",
    },
  })
    .then((response) => singleValueParser(response.data.result))
    .catch(() => singleValueParser([]));

export const getOnlineNodesCount = () =>
  Axios.get("", {
    params: {
      method: methods.CurrentNodeCount,
      status: "active",
    },
  })
    .then((response) => singleValueParser(response.data.result))
    .catch(() => singleValueParser([]));

export const getTotalUsers = () =>
  Axios.get("", {
    params: {
      method: methods.CurrentSessionAddressCount,
    },
  })
    .then((response) => singleValueParser(response.data.result))
    .catch(() => singleValueParser([]));

export const getTodayDataConsumed = () =>
  Axios.get("", {
    params: {
      method: methods.HistoricalSessionBytes,
      limit: 1,
      sort: "-timestamp",
      timeframe: "day",
    },
  })
    .then((response) => {
      const totalBytes = response.data.result.reduce((prev, curr) => {
        return (
          prev +
          Number.parseInt(curr.value.download) +
          Number.parseInt(curr.value.upload)
        );
      }, 0);
      return dataParser(totalBytes);
    })
    .catch(() => singleValueParser([]));

export const getTotalDataConsumed = () =>
  Axios.get("", {
    params: {
      method: methods.TotalSessionBytes,
    },
  })
    .then((response) => {
      const totalBytes = response.data.result.reduce((prev, curr) => {
        return (
          prev +
          Number.parseInt(curr.value.download) +
          Number.parseInt(curr.value.upload)
        );
      }, 0);
      return dataParser(totalBytes);
    })
    .catch(() => singleValueParser([]));

export const getTodayUsers = () =>
  Axios.get("", {
    params: {
      limit: 1,
      method: methods.HistoricalSessionAddressCount,
      sort: "-timestamp",
      timeframe: "day",
    },
  })
    .then((response) => singleValueParser(response.data.result))
    .catch(() => singleValueParser([]));
